import { Incentive } from './incentive';

export const INCENTIVES: Incentive[] = [
  {
    incentive: '',
    category: 'incremental',
    description: ''
  }
];


// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/incentives/incentives.ts